/* eslint-disable */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import Yup from 'yup';
import { geti18n } from '../../utils';
import Button from '../../components/Button';
import ErrorSvg from '../LeadsForm/ErrorSvg';
import { updateZipCodeAction } from '../../redux/actions/zipCode';
import { getCurrentZipCode } from '../../redux/selectors/dma';
import { bindActionCreators } from 'redux';
import {
  FormStyled,
  FormLabelOuterWrapperStyled,
  FormLabelInnerWrapperStyled,
  FormLabelCopyStyled,
  FormInputStyled,
  FormInlineErrorWrapperStyled,
  FormInlineErrorStyled,
  FormInlineErrorSvgWrapperStyled,
  FormInlineErrorCopyStyled,
  DealerFormElemContainerStyled
} from '../LeadsForm/styles';
import {
  StyledDealerListTitle,
  StyledZipSearchByline,
  StyledZipSearchButton,
  SearchSvgWrapperStyled
} from './styles';
import SearchSvg from './SearchSvg';
import { getVendorParam } from '../../redux/selectors/helios';
import './reset.scss';

export const FIELD_NAMES = {
  ZIP_CODE: 'postalCode',
  width: { small: 100, large: 100 }
};

class FormMarkup extends Component {

  static propTypes = {
    selectDealerText: PropTypes.string,
    locateByText: PropTypes.string,
  }

  static defaultProps = {
    selectDealerText: geti18n('leadsFormContent.dealerListZipSearch.selectDealerText'),
    locateByText: geti18n('leadsFormContent.dealerListZipSearch.locateByText'),
  }

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      isQuerying,
      selectDealerText,
      locateByText,
      vendor,
      brand
    } = this.props;
    const renderFieldError = (field) => {
      return errors[field] && touched[field] ? field : undefined;
    };
    const searchFillColor = brand === 'in' ? '#000' : '#c51a47';
    const nnaSearchSvg =  vendor === 'nna' ? <SearchSvg fillColor={searchFillColor}/> : '';
    return (
      <FormStyled noBg={true} onSubmit={handleSubmit} className='dealer-list-zip-form'>
        <StyledDealerListTitle>{selectDealerText}</StyledDealerListTitle>
        <DealerFormElemContainerStyled>
          <StyledZipSearchByline>{locateByText}</StyledZipSearchByline>
          <FormLabelOuterWrapperStyled fieldError={renderFieldError(FIELD_NAMES.ZIP_CODE)}>
            {errors[FIELD_NAMES.ZIP_CODE] &&
              touched[FIELD_NAMES.ZIP_CODE] && (
                <FormInlineErrorWrapperStyled fieldError={renderFieldError(FIELD_NAMES.ZIP_CODE)} >
                  <FormInlineErrorStyled>
                    <FormInlineErrorSvgWrapperStyled>
                      <ErrorSvg />
                    </FormInlineErrorSvgWrapperStyled>
                    <FormInlineErrorCopyStyled>{errors[FIELD_NAMES.ZIP_CODE]}</FormInlineErrorCopyStyled>
                  </FormInlineErrorStyled>
                </FormInlineErrorWrapperStyled>
              )}

            <FormLabelInnerWrapperStyled fieldError={renderFieldError(FIELD_NAMES.ZIP_CODE)} dealerList={true}>
              <FormInputStyled
                name={FIELD_NAMES.ZIP_CODE}
                type="text"
                value={values[FIELD_NAMES.ZIP_CODE]}
                maxLength="5"
                onChange={handleChange}
                onBlur={handleBlur}
                fieldError={renderFieldError(FIELD_NAMES.ZIP_CODE)}
                dealerList={true}
                disabled={isQuerying}
                placeholder={values.postalCode}
              />
            </FormLabelInnerWrapperStyled>
            <SearchSvgWrapperStyled type="submit" disabled={isSubmitting}>
              <StyledZipSearchButton >
                {nnaSearchSvg}
              </StyledZipSearchButton>
            </SearchSvgWrapperStyled>
          </FormLabelOuterWrapperStyled>
        </DealerFormElemContainerStyled>
      </FormStyled>
    );
  }
}

const FormMarkupWithFormik = withFormik({
  mapPropsToValues: (props) => ({
    [FIELD_NAMES.ZIP_CODE]: props.currentZipCode ? props.currentZipCode : ''
  }),
  validationSchema: (props) =>
    Yup.object().shape({
      [FIELD_NAMES.ZIP_CODE]: Yup.string()
        .required(props.zipCodeRequired)
        .matches(/^((?!00000)[0-9]{5})$/, props.zipCodeInvalid)
    }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const { makeDealerQueryRequest, currentZipCode, setNewZipCode, updateDealerByZip } = props;
    updateDealerByZip(values[FIELD_NAMES.ZIP_CODE]);
    setSubmitting(false);
  },
  displayName: 'DealersListZipSearchForm'
})(FormMarkup);

class DealersListZipSearchForm extends Component {
  static propTypes = {
    zipCodeRequired: PropTypes.string,
    zipCodeInvalid: PropTypes.string
  };

  static defaultProps = {
    zipCodeRequired: geti18n('leadsFormContent.dealerListZipSearch.zipCodeRequired'),
    zipCodeInvalid: geti18n('leadsFormContent.dealerListZipSearch.zipCodeInvalid')
  };

  render() {
    const {
      currentZipCode,
      makeDealerQueryRequest,
      isQuerying,
      setNewZipCode,
      updateDealerByZip,
      zipCodeInvalid,
      zipCodeRequired,
      vendor,
      brand
    } = this.props;
    return (
      <FormMarkupWithFormik
        currentZipCode={currentZipCode}
        setNewZipCode={setNewZipCode}
        makeDealerQueryRequest={makeDealerQueryRequest}
        isQuerying={isQuerying}
        updateDealerByZip={updateDealerByZip}
        zipCodeInvalid={zipCodeInvalid}
        zipCodeRequired={zipCodeRequired}
        vendor={vendor}
        brand={brand}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentZip: getCurrentZipCode(state),
  vendor: getVendorParam(state),
  brand: state.environment.BRAND_CHANNEL
});

const mapDispatchToProps = dispatch => ({
  setNewZipCode: bindActionCreators(updateZipCodeAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DealersListZipSearchForm);

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/DealersListZipSearchForm/index.js
 **/